import { FC, ReactNode } from 'react';

export type PageHeaderProps = {
  title: string;
  description?: ReactNode;
  /** The primary page action, placed at the end of the header. */
  action?: ReactNode;
  /** Placement only: typography, spacing and stacking are the header's. */
  className?: string;
};

/**
 * The one page header.
 *
 * The h1 role, the description role, the space below the header and the
 * header/action alignment all live here, so six hand-built *Header rules
 * cannot drift apart again. Below 620px the action drops under the text.
 */
const PageHeader: FC<PageHeaderProps> = ({ title, description, action, className }) => (
  <header className={['ui-page-header', className].filter(Boolean).join(' ')}>
    <div className="ui-page-header-text">
      <h1 className="ui-page-title">{title}</h1>
      {description && <p className="ui-page-desc">{description}</p>}
    </div>
    {action}
  </header>
);

export default PageHeader;
